import { FormikValues, useFormik } from 'formik';
import Cookies from 'js-cookie';
import { useAuth } from 'presentation/app/hooks/useAuth';
import { useService } from 'presentation/app/hooks/useService';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY } from 'storage/storageConfig';
import * as Yup from 'yup';

import { LoginView } from './view';
import { InvalidCredentialsError } from 'domain/errors';

export const Login = () => {
  const [error, setError] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('Dados de autenticação inválidos');
  const [loader, setLoader] = useState<boolean>(false);
  const [passwordShow, setPasswordShow] = useState<boolean>(false);

  const navigate = useNavigate();
  const { authenticationService } = useService();
  const { auth, currentUser, saveAuth, setCurrentUser } = useAuth();

  const savedCredentials = Cookies.get(
    RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY,
  );

  const validation: FormikValues = useFormik({
    enableReinitialize: true,

    initialValues: {
      cpf: savedCredentials ? JSON.parse(savedCredentials)?.cpf : '',
      password: '',
      keepMeSignedIn: savedCredentials ? true : false,
    },
    validationSchema: Yup.object({
      cpf: Yup.string().required('Campo obrigatório').cpfType('CPF inválido'),
      password: Yup.string().required('Campo obrigatória'),
      keepMeSignedIn: Yup.boolean(),
    }),
    onSubmit: async (values) => {
      setLoader(true);
      try {
        const response =
          await authenticationService.authenticationLogin(values);
        saveAuth(response);
        setCurrentUser(response);
        Cookies.set('authUser', JSON.stringify(response));
        validation.values.keepMeSignedIn
          ? Cookies.set(
              RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY,
              JSON.stringify({
                keepMeSignedIn: values.keepMeSignedIn,
              }),
            )
          : Cookies.remove(RADE_ADMIN_SALVED_KEEP_ME_SIGNED_IN_COOKIE_KEY);

        navigate('/dashboard');
      } catch (error) {
        setLoader(false);
        setErrorMessage(error instanceof InvalidCredentialsError ? error.message : 'Dados de autenticação inválidos');
        saveAuth(undefined);
        setError(true);
      }
    },
  });

  useEffect(() => {
    if (auth || currentUser) {
      navigate('/dashboard', { replace: true });
    }
  }, [auth, currentUser, navigate]);

  return (
    <LoginView
      error={error}
      errorMessage={errorMessage}
      loader={loader}
      validation={validation}
      passwordShow={passwordShow}
      nome={''}
      setPasswordShow={setPasswordShow}
    />
  );
};
